<template>
<div class="chapter">
<div class="inner_page">
<div class="dochead" id="pgepubid00000">
<h2 class="author" id="calibre_pb_0">R.M. Ballantyne</h2>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sec001_split_000.vue?6f3742d6